import React from "react";
import { ReactComponent as NotFoundTimesIcon } from "../../assets/icons/NotFoundTimes.svg";
import styles from "./NotFound.module.css";

interface NotFoundProps {
  type: "noService" | "noReservations"; // نوع پیغام NotFound
  selectedService?: string;
  selectedPartner?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ type, selectedService, selectedPartner }) => {
  return (
    <div className={styles.notFoundContainer}>
      <NotFoundTimesIcon className={styles.notFoundIcon} />
      {type === "noService" ? (
        <p className={styles.noReservations}>
          سرویس {selectedService ?? "نامشخص"} توسط {selectedPartner ?? "هیچ آرایشگری"} در دسترس نیست.
        </p>
      ) : (
        <p className={styles.noReservations}>هیچ سرویسی برای این روز ثبت نشده است.</p>
      )}
    </div>
  );
};

export default NotFound;
